import createConverter from './lib/create_converter';
import CustomerNote from 'models/customer_note';

export default createConverter(CustomerNote);
